/**
 * OC Transcript Footer Component
 * Determines what to render in the transcript footer area
 * - Uses custom transcriptFooter if provided
 * - Otherwise shows AskHumanBox if showAskHumanButton is true
 * - Otherwise renders nothing
 */

import React from 'react';

import { useOcFabWidgetOptions } from '../../contexts/OcFabWidgetOptionsContext';
import AskHumanBox from './AskHumanBox';

/**
 * OcTranscriptFooter Component
 * Centralizes transcript footer logic to avoid duplication
 * between ChatInnerWithHistory and ChatInnerWithoutHistory
 */
export const OcTranscriptFooter: React.FC = () => {
    const { transcriptFooter, showAskHumanButton } = useOcFabWidgetOptions();

    // If custom footer provided, use it
    if (transcriptFooter !== undefined) {
        return <>{transcriptFooter}</>;
    }

    // Otherwise, show Ask Human box if enabled
    if (showAskHumanButton) {
        return <AskHumanBox />;
    }

    // No footer
    return null;
};

export default OcTranscriptFooter;

